/**
 * @generated SignedSource<<15562924c2a53d36fd84547324b2b7ed>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OrderDirection = "ASC" | "DESC" | "%future added value";
export type OrganizationMembershipsProfileFieldStatus = "not_responded" | "responded" | "%future added value";
export type ProductRole = "instructor" | "manager" | "member" | "%future added value";
export type CreateProductMembershipsCSVDataInput = {
  excludeViewer?: boolean | null;
  groupIds?: ReadonlyArray<string> | null;
  ids?: ReadonlyArray<string> | null;
  memberGroupFilterInput?: MemberGroupFilterInput | null;
  orderBy?: OrderByInput | null;
  productId: string;
  profileFields?: ReadonlyArray<OrganizationMembershipsProfileFieldFilter> | null;
  roles?: ReadonlyArray<ProductRole> | null;
  search?: string | null;
};
export type OrganizationMembershipsProfileFieldFilter = {
  id: string;
  optionId?: string | null;
  status?: OrganizationMembershipsProfileFieldStatus | null;
};
export type OrderByInput = {
  direction: OrderDirection;
  field: string;
};
export type MemberGroupFilterInput = {
  memberGroupId?: string | null;
  unassigned?: boolean | null;
};
export type ProductMembershipsExportCsvButtonMutation$variables = {
  input: CreateProductMembershipsCSVDataInput;
};
export type ProductMembershipsExportCsvButtonMutation$data = {
  readonly response: {
    readonly downloadCSVLink: string | null;
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
  };
};
export type ProductMembershipsExportCsvButtonMutation = {
  response: ProductMembershipsExportCsvButtonMutation$data;
  variables: ProductMembershipsExportCsvButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateProductMembershipsCSVDataResponse",
    "kind": "LinkedField",
    "name": "createProductMembershipsCSVData",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "downloadCSVLink",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProductMembershipsExportCsvButtonMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProductMembershipsExportCsvButtonMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "48013bf9d4675f396c225c4c2939f964",
    "id": null,
    "metadata": {},
    "name": "ProductMembershipsExportCsvButtonMutation",
    "operationKind": "mutation",
    "text": "mutation ProductMembershipsExportCsvButtonMutation(\n  $input: CreateProductMembershipsCSVDataInput!\n) {\n  response: createProductMembershipsCSVData(input: $input) {\n    downloadCSVLink\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6c3b388e929c48e954441ac5dbde265d";

export default node;
